import { Swiper, Navigation, Pagination } from 'swiper/dist/js/swiper.esm.js';
Swiper.use([Navigation, Pagination]);

import ServiceLocator from "../../../global/service-locator";
import SectionVideo from "../../../components/base/section-video";
import HistorySection from "./history-section";
import CompaniesSlider from "../../../components/companies-slider";
import BlockTabsTeam from "./block-tabs-team";
import ReviewsSlider from "../../../components/reviews-slider";

export default class PageModule {
	constructor() {
		this.modalService = ServiceLocator.instance.modalService;

		this.initSectionVideo();
		this.initHistorySection();
		this.initCompaniesSlider();
		this.initReviewSlider();
		this.initBlockTabs();
		this.registerImageModal();
		this.registerConvenienceModal();

		if (window.matchMedia('(max-width: 600px)').matches) {
			this.initConvenienceSlider();
		}
	}

	initSectionVideo() {
		this.sectionVideo = new SectionVideo({
			$root: document.getElementById('heroSectionVideo'),
			id: 'about-school'
		});
	}

	initHistorySection() {
		const $historySection = document.querySelector('.section.-history');

		if ($historySection) {
			this.historySection = new HistorySection({ $root: $historySection });
		}
	}

	initConvenienceSlider() {
		const swiper = new Swiper('#swiper-convenience', {
			pagination: {
				el: '.swiper-slider_pagination',
				clickable: true
			},
			spaceBetween: 15,
			slidesPerView: 1,
			slidesPerGroup: 1
		});
	}

	initCompaniesSlider() {
		this.companiesSlider = new CompaniesSlider();
	}

	initReviewSlider() {
		this.reviewsSlider = new ReviewsSlider();
	}

	initBlockTabs() {
		const $team = document.getElementById('team');

		if (!$team) return;

		this.blockTabs = new BlockTabsTeam({
			$root: $team
		});
	}

	registerImageModal() {
		const $triggers = Array.from(document.querySelectorAll('[data-modal-trigger="image"]'));

		if ($triggers.length) {
			this.modalService.register('image', $triggers, {
				withCloseBtn: true,
				beforeOpen: ($trigger) => {
					if (!$trigger.dataset || !$trigger.dataset.imageSrc) {
						throw new Error('Image Modal: Image source data attribute is not defined.');
					}

					const img = new Image();
					img.src = $trigger.dataset.imageSrc;
					img.className = 'responsive-image_img';

					const $imageBody = this.modalService.getItem('image').$root.querySelector('.responsive-image_body');
					$imageBody.append(img);
				},
				afterClose: () => {
					const $imageBody = this.modalService.getItem('image').$root.querySelector('.responsive-image_body');
					$imageBody.innerHTML = '';
				}
			});
		}
	}

	registerConvenienceModal() {
		const $triggers = Array.from(document.querySelectorAll('[data-modal-trigger="convenience"]'));

		if ($triggers.length) {
			this.modalService.register('convenience', $triggers, {
				beforeOpen: ($trigger) => {
					const $modal = this.modalService.getItem('convenience').$root;
					const $card = $trigger.querySelector('.convenience_popup').cloneNode(true);
					$card.classList.remove('visually-hidden');

					$modal.append($card);
					lozadObserver.observe();
				},
				afterClose: () => {
					const $modal = this.modalService.getItem('convenience').$root;
					$modal.innerHTML = '';
				}
			})
		}
	}
}